"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.anti-hallucination.disabled': '反幻觉功能在您当前的计划中不可用。',
};
